import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { withContent } from '@bubbletea/core';
import { IContent } from '../../../types';
import goToSection from '../../../utils/goToSection';
import Video from '../../../core/UI/Video';
import SubscriptionButtons from '../../UI/Button/SubscriptionButtons';
import Title from '../../UI/Title';
import { RocksmithPlusLogo, ForwardIcon } from '../../UI/Icons';

import {
  SectionContainer,
  InnerContent,
  OpacityFilter,
  AvailableOn,
  HeroContainer,
  RockSmithPlusContainer,
  Content,
  ForwardIconContainer,
  LegalContainer,
} from './styles';

import BgHeroVideoWebm from '../../../assets/bg-hero.webm';
import BgHeroVideoMp4 from '../../../assets/bg-hero.mp4';
import sendEvent from '../../../utils/sendEvent';
import { IStoreState } from '../../../types/store';
import Legal from '../Legal';
import { TFreeTrialPromo } from '../../../features/windowSlice';
import { Global } from '../../../types/generatedContent';

interface IHeroProps {
  context: IContent;
}

const formatText = (text: string, freeTrial: TFreeTrialPromo | boolean | undefined, global: Global) => {
  if (freeTrial !== undefined) {
    return typeof freeTrial !== 'boolean'
      ? text
          .replace('{DURATION}', freeTrial.duration.toString())
          //@ts-ignore
          .replace('{DURATION_UNIT}', global[freeTrial.durationUnit])
      : text;
  } else {
    return text;
  }
};

// const formatFreeTrialLegalLine = (text: string, freeTrial: TFreeTrialPromo | boolean | undefined, global: Global) => {
//   if (freeTrial !== undefined) {
//     return typeof freeTrial !== 'boolean'
//       ? text
//           .replace('{PRICE}', freeTrial.formattedBasePrice)
//           //@ts-ignore
//           .replace('{DURATION_UNIT}', global[freeTrial?.productSubscriptionDuration])
//       : text;
//   } else {
//     return text;
//   }
// };

const Hero = ({ context }: IHeroProps) => {
  const contentSelector = useSelector((state: IStoreState) => ({
    analyticsLoaded: state.app.analyticsLoaded,
  }));
  const { fetching, freeTrialItem, freeTrialDetected } = useSelector((state: IStoreState) => state.windowVars);
  const { analyticsLoaded } = contentSelector;
  const { global, hero } = context.googlesheet;
  const { description, freeTrial, title, nowAvailableOnPC } = hero;
  const [impressionEventRegistered, setImpressionEventRegistered] = useState(false);
  const innerWidthRef = useRef<HTMLDivElement | undefined>();
  const [videoMinHeight, setVideoMinHeight] = useState<number>(600);

  useEffect(() => {
    const impressionEventDetails = {
      location: 'hero banner',
      category: 'scroll',
      locationPosition: 1,
      action: 'visible',
    };
    if (analyticsLoaded && impressionEventRegistered) {
      setImpressionEventRegistered(false);
      sendEvent(impressionEventDetails, 'impressionevent');
    }
  }, [impressionEventRegistered, analyticsLoaded]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
  }, []);

  useEffect(() => {
    handleResize();
  }, [innerWidthRef?.current?.offsetHeight, freeTrialDetected]);

  const handleResize = () => {
    if (innerWidthRef?.current?.offsetHeight !== undefined) {
      setVideoMinHeight(innerWidthRef?.current?.offsetHeight);
    }
  };
  const eventDetails = { location: 'hero banner', locationPosition: 1 };

  return (
    <SectionContainer>
      <HeroContainer
        whileInView={'sendevent'}
        onAnimationStart={() => setImpressionEventRegistered(true)}
        viewport={{ once: true }}
      >
        <OpacityFilter minHeight={videoMinHeight}>
          <Video nativeProps={{ autoPlay: true, muted: true }} muted>
            <source src={BgHeroVideoWebm} type="video/webm" />
            <source src={BgHeroVideoMp4} type="video/mp4" />
          </Video>
        </OpacityFilter>
        <InnerContent isFreeTrial={!fetching && freeTrialDetected} ref={innerWidthRef}>
          <div>
            {/*{!fetching && freeTrialDetected ? (*/}
            {/*  <>*/}
            {/*    <PickContainer>*/}
            {/*      <DiscountBlackIcon />*/}
            {/*      <FreeTrialText>{global.freeTrial}</FreeTrialText>*/}
            {/*    </PickContainer>*/}
            {/*  </>*/}
            {/*) : null}*/}
            <RockSmithPlusContainer>
              <RocksmithPlusLogo />
              <AvailableOn>{nowAvailableOnPC}</AvailableOn>
            </RockSmithPlusContainer>
            <Content>
              <Title as="h1" textAlign="left">
                {!fetching ? formatText(freeTrialDetected ? freeTrial.title : title, freeTrialItem, global) : title}
              </Title>
              <p>{description}</p>
            </Content>
            <SubscriptionButtons tracking={eventDetails} />
            {/*{freeTrialDetected && (*/}
            {/*  <LegalLineText>{formatFreeTrialLegalLine(legalLine, freeTrialItem, global)}</LegalLineText>*/}
            {/*)}*/}
          </div>
        </InnerContent>
        <ForwardIconContainer onClick={() => goToSection('features')}>
          <ForwardIcon animated />
        </ForwardIconContainer>
      </HeroContainer>
      <LegalContainer>
        <Legal />
      </LegalContainer>
    </SectionContainer>
  );
};

export default withContent(Hero);
